module.exports = __webpack_public_path__ + "static/media/reinikainen.d5200e37.png";